<template>
  <div v-if="hasPhotos">
    <div>
      <p><strong>{{ photosTitle }}</strong></p>
    </div>
    <div class="photos-grid">
      <div
        v-for="(photo, index) in displayedPhotos"
        :key="photo.id"
        class="photo-item"
      >
        <img
          :src="photo.url"
          :alt="photo.name"
          class="photo-img"
        />
        <div class="photo-overlay">
          <div v-if="photo.originalData" class="photo-details">
            <small>{{ photo.originalData.nom_source }}</small>
          </div>
        </div>
      </div>
    </div>
    <div class="photos-info">
      <span class="help-text">
        {{ photoLimitInfo }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostPhotosCustom',
  props: {
    photos: {
      type: Array,
      required: true,
      default: () => []
    },
    networkName: {
      type: String,
      required: true
    },
    statusPost: {
      type: String,
      default: ''
    },
    isCurrentlyPublished: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayedPhotos () {
      // Limite selon le réseau social
      if (this.networkName.toLowerCase() === 'google') {
        // Pour Google, seulement 1 photo (la première)
        return this.photos.slice(0, 1)
      } else {
        // Pour les autres réseaux sociaux, 10 photos maximum
        return this.photos.slice(0, 10)
      }
    },
    hasPhotos () {
      return this.displayedPhotos && this.displayedPhotos.length > 0
    },
    photosTitle () {
      return this.networkName.toLowerCase() === 'google'
        ? 'Photo pour Google'
        : 'Photos pour ' + this.networkName
    },
    photoLimitInfo () {
      if (this.networkName.toLowerCase() === 'google') {
        return this.$t('socialMedia.onlyOnePhoto')
      } else {
        const totalPhotos = this.photos.length
        const displayedCount = this.displayedPhotos.length
        if (totalPhotos > 10) {
          return `${displayedCount}/10 photos affichées (${totalPhotos - displayedCount} photos non affichées).`
        } else {
          return `${displayedCount} photo${displayedCount > 1 ? 's' : ''} ser${displayedCount > 1 ? 'ont' : 'a'} diffusée${displayedCount > 1 ? 's' : ''} sur ${this.networkName}.`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
  margin: 10px 0;
}

.photo-item {
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  background: #f9fafb;
  aspect-ratio: 1;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
}

.photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.photo-item:hover .photo-img {
  transform: scale(1.05);
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 8px;
}

.photo-item:hover .photo-overlay {
  opacity: 1;
}

.photo-details {
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px;
  font-weight: 500;
}

.photos-info {
  margin-top: 8px;
}

.help-text {
  font-size: 12px;
  color: #666;
  font-style: italic;
}

@media (max-width: 768px) {
  .photos-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
}
</style>
